import type { ComponentLoaderType } from '@grafikr/components';
import { isbot } from 'isbot';

import { getCountryIntent, getCurrentRegion, getRegionIntent } from 'utils/geo';

const Loader: ComponentLoaderType = (_, load) => {
  (async () => {
    // Return early if user agent is a bot
    if (isbot(navigator.userAgent)) {
      return;
    }

    const currentCountry = await getCountryIntent();
    const currentRegion = getCurrentRegion();
    const regionMatch = getRegionIntent(currentCountry);

    if (currentRegion.domain !== regionMatch.domain) {
      load();
    }
  })();

  return () => {};
};

export default Loader;
